/**
 * @description: canvas 相关常量
 */

import {type MaterialType, MaterialTypeValue} from '@/services/material/interface';
import {StoryboardTab} from '@/store/canvas/useFloatingPanelStore';

/**
 * 支持创建的节点类型
 */
export const COMMAND_CREATE_NODE_TYPE = {
    IMAGE: 'image',
    VIDEO: 'video',
    AUDIO: 'audio',
    IMAGE_GENERATOR: 'image-generator',
    VIDEO_GENERATOR: 'video-generator',
    AUDIO_GENERATOR: 'audio-generator',
} as const;

export const CANVAS_ACTION = {
    CREATE_NODE: 'createNode',
    CREATE_NODES_GROUP: 'createNodesGroup',
} as const;

/**
 * 画布类型，区分不同的创作入口，如艺术画布、分集(分集有区分了分镜)等
 */
export const CanvasType = {
    STYLE: 1,
    EPISODE: 3,
    ASSETS: 2,
} as const;

// 不同素材 tab 对应的图片长宽比
export const MATERIAL_TAB_RATIO: Partial<Record<MaterialType, string>> = {
    [MaterialTypeValue.CHARACTER]: '16:9',
    [MaterialTypeValue.SCENE]: '16:9',
    [MaterialTypeValue.PROP]: '3:4',
};

export const STORYBOARD_CREATE_NAME_PREFIX = {
    [StoryboardTab.Reference]: '参考',
    [StoryboardTab.Image]: '分镜图',
    [StoryboardTab.Video]: '分镜视频',
    [StoryboardTab.Audio]: '分镜音频',
};
